import React from 'react';
import { Popover, PopoverAnchor } from '@fiverr-private/popover';
import { Text } from '@fiverr-private/typography';
import { StepperStep, useStepper } from '@fiverr-private/navigation';
import { JobPostBriefL1Icon, ProBadgeL1Icon } from '@fiverr-private/visuals';
import { useBreakpoint } from '@fiverr-private/hooks';
import { SentIcon } from '../../StepsSection/SentIcon';
import { AppI18n } from '../../../../i18n';
import { HowItWorksStepKey } from '../../../types/howItWorksSteps';
import { HowItWorksPopoverContent } from './HowItWorkPopoverContent';

type Step = StepperStep & { label: HowItWorksStepKey };

const STEPS: Step[] = [
    {
        icon: <JobPostBriefL1Icon color="grey_1200" />,
        label: 'step_1',
    },
    {
        icon: <ProBadgeL1Icon color="grey_1200" />,
        label: 'step_2',
    },
    {
        icon: <SentIcon size="sm" />,
        label: 'step_3',
    },
] as const;

export const HowItWorksPopover = () => {
    const { currentStep, nextStep, prevStep, setStepCompleteState, hasNextStep, hasPreviousStep, reset } = useStepper({
        steps: STEPS,
        stepStrategy: 'linear-back',
    });
    const breakpoint = useBreakpoint();

    const isSmallScreen = breakpoint === 'sm' || breakpoint === 'default';

    return (
        <Popover position={isSmallScreen ? 'top' : 'right-end'}>
            <PopoverAnchor>
                <Text size="b_xs" fontStyle="italic" color="bodySecondary" textAlign="end">
                    <AppI18n k="how_it_works.button_text" />
                </Text>
            </PopoverAnchor>
            <HowItWorksPopoverContent
                icon={STEPS[currentStep].icon}
                stepKey={STEPS[currentStep].label}
                currentStep={currentStep}
                hasPreviousStep={hasPreviousStep}
                hasNextStep={hasNextStep}
                onPrevStep={prevStep}
                onAnimationEnd={reset}
                onNextStep={() => {
                    setStepCompleteState(true);
                    nextStep();
                }}
            />
        </Popover>
    );
};
